/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getProjectStatuses = ({ params } = {}) => axios.get(`project_statuses`, { params });